/**
 * Manual donation entry — admin records cash/cheque donations from offline donors.
 *
 * Lives at /app/admin-donations. Composes ManualDonationForm + DonationsTable
 * from /components/donations/AdminDonationsParts.jsx for testability.
 */
import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { ManualDonationForm, DonationsTable } from "@/components/donations/AdminDonationsParts";

const INITIAL = {
  donor_id: "",
  donor_name: "",
  student_id: "",
  category: "general",
  amount: "",
  method: "cash",
  note: "",
};

export default function AdminDonations() {
  const [form, setForm] = useState(INITIAL);
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);

  const refresh = () => api.get("/donor/admin-donations").then((r) => setRows(r.data || []));
  useEffect(() => { refresh().catch(() => {}); }, []);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.donor_name.trim() && !form.donor_id.trim()) { toast.error("Donor name OR donor id required"); return; }
    if (!form.amount) { toast.error("Amount required"); return; }
    setBusy(true);
    try {
      const payload = { ...form, amount: Number(form.amount) };
      Object.keys(payload).forEach((k) => { if (payload[k] === "") delete payload[k]; });
      await api.post("/donor/admin-donations", payload);
      toast.success("Donation recorded");
      setForm(INITIAL);
      refresh();
    } catch (e) {
      toast.error(formatApiErrorDetail(e?.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <DashboardLayout title="Donations (admin)" subtitle="All donations across the trust + manual cash/cheque entry.">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <ManualDonationForm form={form} set={set} busy={busy} onSubmit={submit} />
        <DonationsTable rows={rows} onIssued={refresh} />
      </div>
    </DashboardLayout>
  );
}
